import moment from "moment"
import api from '../api/api-list'

const state = {
  clickMonthStr: '',
  defaultDateStr: moment().format('YYYY-MM-DD'),
  isClick: false,
  fullWeekData: [], // 周视图的日历数据结构
  fullMonthData: [], // 月视图的日历数据结构
  monthThingsData: {},
  weekThingsData: {
    [moment().startOf('weeks').format('YYYY-MM-DD').toString()]: {
      me: [],
      system: []
    }
  },
  currentSunday: moment().startOf('weeks').format('YYYY-MM-DD')
}

const getters = {
  currentMonth: state => {
    if (state.isClick) {
      return {
        dateFormatFont: moment(state.clickMonthStr).format('YYYY年MM月'),
        dateFormatConnect: moment(state.clickMonthStr).format('YYYY-MM-DD'),
        dateMonthKey: moment(state.clickMonthStr).format('YYYY-MM')
      }
    } else {
      return {
        dateFormatFont: moment(state.defaultDateStr).format('YYYY年MM月'),
        dateFormatConnect: moment(state.defaultDateStr).format('YYYY-MM-DD'),
        dateMonthKey: moment(state.defaultDateStr).format('YYYY-MM')
      }
    }
  },
  // currentMonthThingsData: (state, getters) => {
  //   return state.monthThingsData.get(getters.currentMonth.dateMonthKey)
  // },
  currentWeekTingsData: state => state.weekThingsData[state.currentSunday]
}

const actions = {
  getMonthThingsData: async function({ commit, state, getters }) {
    const { dateMonthKey } = getters.currentMonth
    try {
      let res = await api.campusOffers.getCampusMonthCalendar({ date: dateMonthKey })
      if (res.code === 1000) {
        commit('SET_MONTH_THINGS_DATA', { dateMonthKey, monthThingsData: res.data })
      }
    } catch(e) {
      console.log(e)
    }
  },
  getWeekThingsData: async function({ commit, state, getters }) {
    try {
      let res = await api.campusOffers.getCampusWeekCanlendar({ date: state.currentSunday })
      if (res.code === 1000) {
        let {personal_recruitments, system_recruitments} = res.data
        commit('SET_WEEK_THINGS_DATA', {
          me: personal_recruitments,
          system: system_recruitments
        })
      }
    } catch (e) {
      console.log(e)
    }
  }
}

const mutations = {
  ['SET_CLICK_MONTH_STR'](state, str) {
    state.clickMonthStr = str
  },
  ['SET_DEFAULT_DATE_STR'](state, str) {
    state.defaultDateStr = str
  },
  ['SET_IS_CLICK'](state, isClick) {
    state.isClick = isClick
  },
  ['SET_FULL_WEEK_DATA'](state, fullWeekData) {
    state.fullWeekData = fullWeekData
  },
  ['SET_FULL_MONTH_DATA'](state, fullMonthData) {
    state.fullMonthData = fullMonthData
  },
  ['SET_MONTH_THINGS_DATA'](state, { dateMonthKey, monthThingsData }) {
    let data = JSON.parse(JSON.stringify(state.monthThingsData))
    data[dateMonthKey] = monthThingsData
    state.monthThingsData = data
  },
  ['SET_CURRENT_SUNDAY'](state, value) {
    state.currentSunday = value
  },
  ['SET_WEEK_THINGS_DATA'](state, value) {
    let data = JSON.parse(JSON.stringify(state.weekThingsData))
    data[state.currentSunday] = value
    state.weekThingsData = data
  },
  ['SET_ALL_WEEK_THINGS'](state, value) {
    state.weekThingsData = value
  }
}

export default {
	namespaced: true,
	state,
  getters,
	actions,
	mutations
}
